import { render, staticRenderFns } from "./accountCompanyType.vue?vue&type=template&id=8686b18c&"
import script from "./accountCompanyType.vue?vue&type=script&lang=js&"
export * from "./accountCompanyType.vue?vue&type=script&lang=js&"
import style0 from "./accountCompanyType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports